module.exports = __webpack_public_path__ + "img/mobileapplication1.ccc751be.png";